import * as angular from 'angular';
export function registerComponents(config: { [key: string]: any }, ngModule: angular.IModule): angular.IModule {
    for (const key of Object.keys(config)) {
        const obj = config[key];
        ngModule.component(obj.componentId, typeof obj === 'function' ? new obj : obj);
    }
    return ngModule;
}

export function registerServices(config: { [key: string]: any }, ngModule: angular.IModule): angular.IModule {
    for (const key of Object.keys(config)) {
        const obj = config[key];
        ngModule.service(obj.componentId, obj);
    }
    return ngModule;
}

export function registerConfigs(config: { [key: string]: any }, ngModule: angular.IModule): angular.IModule {
    for (const key of Object.keys(config)) {
        const obj = config[key];
        ngModule.config(obj.componentId);
    }
    return ngModule;
}

export function registerServiceId(modules: any, ngModule: angular.IModule): angular.IModule {
    for (const key of Object.keys(modules)) {
        ngModule.service(modules[key].serviceId, modules[key]);
    }
    return ngModule;
}